import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  tenCoSoCheBien: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  maSoThue: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  nguoiDaiDien: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  cccd: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required)
});
